// Free Carto GL tile styles — no API key required
export const light = 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json';
export const dark  = 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json';
